import { FeatureFlag } from "@/types/breeze/FeatureFlag";
import { BaseService } from "../BaseService";

export class FeatureFlagService extends BaseService {
  public async getFeatureFlags(): Promise<FeatureFlag[]> {
    return this.getRequest("/feature-flags", false);
  }
}

export const featureFlagService = new FeatureFlagService();
